import { FC } from 'react';
import { Tr } from '@utils';
import { DealerConfig } from '@services';
import { Grid } from '@mui/material';
import { FormikSwitch } from '@components/common';

export interface IDealerStockConfigurationProps {
	config?: Partial<DealerConfig>;
	onChange?: (values: Partial<DealerConfig>) => void;
}

export const DealerStockConfiguration: FC<IDealerStockConfigurationProps> = ({ config, onChange }) => {
	return (
		<Grid container rowSpacing={5} columnSpacing={4}>
			<Grid item xs={6}>
				<FormikSwitch
					withoutFormik
					name="isOpenToB2C"
					title={<Tr.Portal path="configuration.dealer-config.stock.open-to-b2c" />}
					direction="row"
					checked={config?.isOpenToB2C || false}
					onChange={(_e, checked) => onChange?.({ isOpenToB2C: checked })}
				/>
			</Grid>
		</Grid>
	);
};
